<template>
  <div>
    <icon name="exclamation-triangle" scale="3.5"></icon>
    <p class="u-font-lg u-row-space-2" v-html="message"></p>
    <p v-if="canCloseApp">
      <button class="button s-vam" v-on:click="closeApp()" :title="$t('close_app')">
        <icon name="close"></icon>&nbsp;
        <span>{{ $t('close') }}</span>
      </button>
    </p>
  </div>
</template>

<script>
  export default {
    props: {
      error: {
        type: Error,
        default: null
      }
    },

    computed: {
      message () {
        let ymlKey = this.error.ymlKey
        let bookTitle = this.error.bookTitle
        if (ymlKey) return this.$i18n.t(ymlKey, { title: bookTitle })
        return this.$i18n.t('generic_error')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/app_messages/Error.vue